import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import TitleLine from './titleLine';
import ArticleArea from './articleArea';
import Assess from '../../../article/layout/content/rightContent/assess';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                type,
                docData,
                docData: {
                    title,
                    newsTime,
                    updateTime,
                    videosPluginData,
                    slidesPluginData,
                    surveyPluginData,
                    subscribe = {},
                },
                asideAd2,
                asideAd3,
                assess,
                commentAd,
                commentBottomAd,
                hasCopyRight = false,
            },
        } = this.props;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };
        const captionData = {
            title,
            newsTime,
            updateTime,
            subscribe,
            hasCopyRight,
        };

        return (
            <div className={styles.container}>
                <div className={styles.left_articleArea}>
                    <TitleLine content={captionData} />
                    <ArticleArea
                        articleData={docData}
                        pluginData={pluginData}
                        commentAd={commentAd}
                        commentBottomAd={commentBottomAd}
                        type={type}
                    />
                </div>
                <div className={styles.right_adArea}>
                    <Ad content={asideAd2} styleName={styles.asideAd} />
                    <div className={styles.space25} />
                    <Assess content={assess} />
                    <div className={styles.space40} />
                    <Ad content={asideAd3} styleName={styles.asideAd} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
